module.exports = __webpack_public_path__ + "img/admin-dashboard-dark.4071db29.jpg";